<div class="colorGrid">
    @for (color of colors; track $index) {
        <div class="colorItem-wrapper">
            <div
                class="colorItem colorItem-circle"
                [ngStyle]="{ 'background-color': color }"
                (click)="selectColor(color)"
            ></div>
            @if (color === form.value[id]) {
                <i
                    class="pi pi-check colorItem"
                    [ngStyle]="{ 'color': color | colorContrast }"
                ></i>
            }
        </div>
    }
</div>
